export const ENGLISH_TRANSLATIONS = {
    sammio: {
        site: {
            name: 'Sammio - Radiation and Nuclear Safety Authority (STUK)',
            name_short: 'Sammio'
        },
        search: 'Search',
        search_filters: {
            tip: 'Select subject areas to narrow your search results'
        },
        search_redirect: 'Search',
        search_card: 'Search',
        help: 'Help',
        announcement: "News",
        accessibility: 'Accessibility statement',
        bookmarks: {
            title: 'Bookmarks',
            title_field: 'Bookmark name',
            add_all: 'Add all results to bookmarks',
            clear_all: 'Remove all results from bookmarks',
            back_to_search_results: 'Back to previous search results',
            reorder: 'Reorder search results',
            empty: 'Bookmark list empty.',
            loaded_empty: 'The requested bookmark was not found.',
            show_in_cards: 'Show in bookmarks',
            prompt_add_x_to_bookmarks: 'Are you sure you want to add {count} results to bookmarks?',
            prompt_clear_bookmarks: 'Are you sure you want to clear all bookmarks?',
            bookmark_selected_info: 'Bookmark selected. Use up and down buttons to move active bookmark to a new place. Press ESC key to exit bookmark editing.',
            bookmark_not_selected_info: 'Bookmark not selected. Use space bar to activate bookmark. Press ESC key to exit bookmark editing.',
            bookmark_moved_up: 'Bookmark moved up. New location is {location}',
            bookmark_moved_down: 'Bookmark moved down. New location is {location}',
            add_to_bookmarks: 'Add target to the bookmarks',
            added_to_bookmarks: 'Target added to the bookmarks',
            remove_from_bookmarks: 'Remove target from the bookmarks',
            removed_from_bookmarks: 'Target removed from the bookmarks',
            items: 'Targets'
        },
        bookmarks_get: {
            title: 'Bookmarks'
        },
        statutes: {
            title: 'Statutes',
            side_navigation_go_to: 'Go to current page in the side navigation',
            side_navigation_no_results: 'No current page found in the side navigation. Select new page.'
        },
        statutes_root: {
            title: 'Statutes'
        },
        statutes_card: {
            title: 'Statutes'
        },
        frequentsearches: {
            title: "Pre-made searches"
        },
        subsectionTitle: 'Requirement',
        subsection: 'requirement',
        justification: 'Rationale',
        guidance: 'Guidance',
        export_pdf: 'Export PDF',
        share: 'Share',
        print: 'Print',
        show: 'Search from the following',
        target_fields: 'Search from',
        filter_results: 'Filter results',
        act: 'Act',
        decree: 'Decree',
        regulation: 'Regulation',
        by_radiation_act: 'by Radiation Act',
        by_subsection: 'by Requirement',
        provision: 'Provision',
        issued: 'issued',
        regulated: 'regulated',
        under: 'under',
        related_decrees: 'Related decrees',
        decrees: 'Decrees',
        related_regulations: 'Related regulations',
        regulations: 'Regulations',
        related_decrees_and_regulations: 'Related decrees and regulations',
        open: 'Open',
        openMenu: 'Open menu',
        close: 'Close',
        closeMenu: 'Close menu',
        yes: 'Yes',
        no: 'No',
        clear: 'Clear',
        copy: "Copy",
        link_to_page: 'Link to page',
        do_search: 'Search',
        remove: 'Remove',
        removed: 'Removed',
        filter: 'Filter',
        remove_filter: 'Remove filter',
        keyword: 'Keyword',
        searched_with_synonym: 'Showing also results with keyword',
        active_filters: 'Active filters',
        show_x_results: 'Show {count} results',
        added_x_results: 'Added {count} results',
        added_one_result: 'Added 1 result',
        clear_filters: 'Clear filters',
        search_field_placeholder: 'Search Requirements, Rationales and Guidances by keyword',
        and: 'and',
        this_law_contains: 'This Act contains',
        save: 'Save',
        cancel: 'Cancel',
        selected: 'Selected',
        unselected: 'Unselected',
        url_copied_to_clipboard: 'URL copied to clipboard.',
        attachments_title: 'Attachments',
        errors: {
            common_error: "Oops, something went wrong. Please try again after a moment."
        },
        navigation: {
            title: "Main navigation",
            site_pages: "Web pages",
            logo_text: "Sammio - to the search page",
            saados: "Acts menu",
            muistilista: 'Bookmarks',
            haku: "Search filters",
            menu: "Menu",
            usein_haetut: "Pre-made searches menu"
        },
        dropdown: {
            select_language: "Select language",
            description:  "Select site language",
            change_to_language: "Change page language to {lang}"
        },
        pagination: {
            next: 'Move to next page',
            previous: 'Move to previous page',
            goto_page: 'Move to page {0}',
            wrapper: 'Search results paging',
            current: 'Current page {0}'
        },
        loading: {
            on: 'Loading. Please wait.',
            done: 'Loading finished.'
        },
        page_top: 'To page top',
        language: {
            fi: "Finnish",
            sv: "Swedish",
            en: "English"
        },
        news: {
            title: "News",
            no_publications: "No published announcements",
            loading: "Loading latest news...."
        }
    }
};
